import { FC } from 'react';
import { FormatDate } from 'src/components/format-date';
import { MessageBox } from 'src/components/message-box';
import { Stack } from 'src/components/stack';
import styled from 'styled-components';

export const Runtime: FC<{
  start: string;
  end: string;
}> = ({ start, end }) => {
  return (
    <>
      <FormatDate value={start} type="date-time" /> -{' '}
      <FormatDate value={end} type="date-time" />
    </>
  );
};

export const Disclaimer: FC<{}> = () => {
  return (
    <MessageBox
      type="info"
      title="Please note when using this form to report external trades that:"
      data-testid="external-trade-disclaimer"
    >
      <Stack gap={2}>
        <p>
          PRISMA does not exercise any control over the trade data entered via
          this form and is under no obligation to identify errors or verify the
          accuracy, truthfulness, or completeness of the relevant trade data
          entered and submitted via this form.
        </p>
        <p>
          PRISMA undertakes to forward the trade data entered via this form to
          the designated recipients. The sole responsibility for the accuracy,
          completeness, timeliness, and content of the trade data entered rests
          with the Customer on whose behalf the report is to be sent.
        </p>
        <p>
          PRISMA will report this transaction data in accordance with its REMIT
          reporting obligations and the reporting agreement concluded with you.
        </p>
      </Stack>
    </MessageBox>
  );
};

export const PriceConversionDisclaimer: FC<{}> = () => {
  return (
    <MessageBox
      type="info"
      data-testid="external-trade-price-conversion-disclaimer"
    >
      <p>
        To be in line with the ACER reporting requirements, the price, tariff
        and surcharge values will be converted to EUR/kWh/h with the latest
        available FX-rate. To ensure correct reporting, please enter already
        converted values if a conversion with the latest available FX-rate is
        not adequate.
      </p>
    </MessageBox>
  );
};

export const LeftPaddedSpan = styled.span`
  padding-left: 1rem;
`;
